/* eslint-disable no-param-reassign */
// import { format } from "date-fns";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const PdfTrafficReportByCountry = ({ arr }) => {
  // eslint-disable-next-line new-cap
  const doc = new jsPDF("p", "mm", "a4");
  // Add Image To PDF
  const imgWidth = 20;
  const imgHeight = 20;

  // Static base64 for example purposes
  const toPng =
    "data:image/png;base64,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";

  doc.addImage(toPng, "PNG", 183, 5, imgWidth, imgHeight);
  autoTable(doc, {
    head: [[""]],

    didParseCell(cell) {
      cell.cell.styles.fontStyle = "normal";
    },
    didDrawPage(data) {
      // Header
      doc
        .text("Lokalee", data.settings.margin.right + 170, 25)
        .setFontSize(20)
        .setFont("times", "bold");
      doc.text("Traffic by country reports", 6, 40).setFontSize(16);
      doc.setFont("times", "bold").text("County name:", 5, 60).setFont("times", "normal");
      doc
        .setFont("times", "normal")
        .text(arr[0]?.cityResults[0].country, 40, 60)
        .setFontSize(12)
        .setFont("times", "normal");
      doc.text("Traffic by country report", 5, 65);
      doc.line(5, 67, 204, 67);
    },

    tableLineWidth: 0,
    tableLineColor: "black",
    startY: 10,
    startX: 20,
    theme: "plain",
    // format: "c0",
    putOnlyUsedFonts: true,
    pageBreak: "auto",
    cellWidth: "wrap",
    // cellPadding: 15,

    lineWidth: 0.1,
    // columnWidth: 93, // 'auto', 'wrap' or a number
  });

  if (arr?.length > 0) {
    let startYNb = 83;
    let startYNbCity = 78;
    arr?.forEach((val, index) => {
      if (val && val?.cityResults && val?.cityResults?.length > 0) {
        const bodyRes = val?.cityResults?.map(({ name, traffic, totalTickets, events }) => [
          name,
          traffic?.screenPageViews,
          traffic?.totalUsers,
          traffic?.newUsers,
          events?.signups,
          events?.logins,
          traffic?.purchaseRevenue,
          totalTickets,
          traffic?.averagePurchaseRevenuePerUser,
        ]);
        doc.setFont("times", "normal").setFontSize(10);
        doc.setFont("times", "normal").text("City:", 5, startYNbCity).setFontSize(10);
        doc.setFont("times", "normal").text(val.cityName, 13, startYNbCity);
        autoTable(doc, {
          startY: startYNb,
          styles: {
            lineColor: "black",

            lineWidth: 0.1,
            cellWidth: "wrap",
          },
          headStyles: {
            fillColor: [171, 171, 171],
          },
          margin: { top: 50, left: 5, right: 5, bottom: 10 },

          didParseCell(cell) {
            cell.cell.styles.fontSize = 9;
            cell.cell.tableWidth = 500;
            if (cell.column.dataKey === 0) {
              // paint.Name header red
              cell.cell.styles.cellWidth = 22;
              //
              // cell.styles.textColor = [255, 0, 0];
            } else if (cell.column.dataKey === 1) {
              // cell.cell.styles.fillColor = "blue";
              cell.cell.styles.cellWidth = 28;
            } else if (cell.column.dataKey === 2) {
              // cell.cell.styles.fillColor = "blue";
              cell.cell.styles.cellWidth = 20;
            } else if (cell.column.dataKey === 3) {
              // cell.cell.styles.fillColor = "blue";
              cell.cell.styles.cellWidth = 20;
              // cell.cell.styles.fontSize = 8;
            } else if (cell.column.dataKey === 4) {
              // cell.cell.styles.fillColor = "blue";
              cell.cell.styles.cellWidth = 20;
              // cell.cell.styles.fontSize = 8;
            } else if (cell.column.dataKey === 5) {
              // cell.cell.styles.fillColor = "blue";
              cell.cell.styles.cellWidth = 20;
              // cell.cell.styles.fontSize = 8;
            } else if (cell.column.dataKey === 6) {
              // cell.cell.styles.fillColor = "blue";
              cell.cell.styles.cellWidth = 20;
              // cell.cell.styles.fontSize = 8;
            } else if (cell.column.dataKey === 7) {
              // cell.cell.styles.fillColor = "blue";
              cell.cell.styles.cellWidth = 18;
              // cell.cell.styles.fontSize = 8;
            } else if (cell.column.dataKey === 8) {
              // cell.cell.styles.fillColor = "blue";
              cell.cell.styles.cellWidth = 32;
              // cell.cell.styles.fontSize = 8;
            } else {
              cell.cell.styles.cellWidth = 30;
            }
          },

          head: [
            [
              "Location",
              "Total views",
              "Total users",
              "New users",
              "Number of sign ups",
              "Number of logins",
              "Revenue",
              "Tickets sold",
              "Conversion ratio (purchases/users)",
            ],
          ],
          body: bodyRes,

          tableLineWidth: 0,
          tableLineColor: "black",
          tableWidth: "auto",
          tableLength: 50,

          startX: 20,
          theme: "plain",
          putOnlyUsedFonts: true,
          pageBreak: "auto",
          // cellPadding: 5,
          lineWidth: 0.1,

          // columnWidth: 100, // 'auto', 'wrap' or a number
        });
        //   });
      }
      if (index < arr.length - 1) {
        startYNb = doc.autoTable.previous.finalY + 20; // Add margin after each table
      }
      if (index < arr.length - 1) {
        startYNbCity = doc.autoTable.previous.finalY + 15; // Add margin after each city
      }
    });
  }

  doc.save("trafficReportByCountry.pdf");
};
export default PdfTrafficReportByCountry;
